const base64ToBytes = (base64) => {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes;
};

/**
 * Decrypts a value encrypted by pm-api's ApiKeyCipher (AES-256-GCM).
 * Expected format: base64(iv).base64(authTag).base64(ciphertext)
 * @param cipherText the encrypted value
 * @param cipherKeyBase64 the AES-256 key (base64), fetched from pm-api via getAccountApiKeyCipherKey
 */
export const decryptApiKeyValue = async (cipherText, cipherKeyBase64) => {
    if (!cipherText || !cipherKeyBase64) return '';

    try {
        const [ivB64, authTagB64, dataB64] = cipherText.split('.');
        const iv = base64ToBytes(ivB64);
        const authTag = base64ToBytes(authTagB64);
        const data = base64ToBytes(dataB64);

        // Web Crypto's AES-GCM expects the auth tag appended to the ciphertext
        const combined = new Uint8Array(data.length + authTag.length);
        combined.set(data, 0);
        combined.set(authTag, data.length);

        const keyBytes = base64ToBytes(cipherKeyBase64);
        const cryptoKey = await window.crypto.subtle.importKey('raw', keyBytes, 'AES-GCM', false, ['decrypt']);
        const decrypted = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv }, cryptoKey, combined);

        return new TextDecoder().decode(decrypted);
    } catch (error) {
        return '';
    }
};
